import { render, staticRenderFns } from "./SaraiBookings.vue?vue&type=template&id=5fe0f339&scoped=true"
import script from "./SaraiBookings.vue?vue&type=script&lang=js"
export * from "./SaraiBookings.vue?vue&type=script&lang=js"
import style0 from "./SaraiBookings.vue?vue&type=style&index=0&id=5fe0f339&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fe0f339",
  null
  
)

export default component.exports